export default{
  responsavelID: {
    value: null,
    options: [],
    required: false,
    state: null,
    code: null
  },
  TipoObraID: {
    value: null,
    options: [],
    required: false,
    state: null,
    code: null
  },
  dataInicioSolicitacao: {
    value: null,
    options: [],
    required: false,
    state: null,
    code: null
  },
  statusVistoria: {
    value: null,
    options: [],
    required: false,
    state: null,
    code: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/Survey/surveyboard-form.js